module.exports = __webpack_public_path__ + "img/amenidades3.ef618dd9.png";